import React from 'react'
import "./maillist.css"

const MailList = () => {
  return (

    <div className='mail'>
      <h1 className="mailTitle">Save time, save money</h1>
      <span className="mailDes">Sign up and we'll send the best deals to you</span>
      <div className="mailInputContainer">
        <input type="text" placeholder='Your email'/>
        <button>Subcribe</button>
      </div>
    </div>

  )
}

export default MailList
